import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { CampaignDTO } from "../../../core/models/campaignDTO.model";
import { MatSelectChange } from "@angular/material";

@Component({
  selector: "kt-campaign-selector",
  templateUrl: "./campaign-selector.component.html",
  styleUrls: ["./campaign-selector.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignSelectorComponent implements OnInit {
  @Input() campaigns: CampaignDTO[] = [];
  @Output() campaignSelected = new EventEmitter<CampaignDTO>();

  constructor() {}

  ngOnInit() {}

  onCampaignSelected($event: MatSelectChange) {
    this.campaignSelected.emit($event.value);
  }
}
